import { Loading } from '../../states/States';
import { useLoad } from '../../views/useLoad';
import { useAppServices } from '../../views/ViewContext';

type HistoryEntry = { at: string; command_name?: string; label: string; actor_name: string | null };

/** Commandes codées du Core sans libellé déclaré : le journal rend leur nom, l'écran le traduit. */
const LABELS: Record<string, string> = {
  RegisterEntity: 'Société créée',
  UpdateEntity: 'Société modifiée',
  RegisterSite: 'Site créé',
  UpdateSite: 'Site modifié',
  RegisterEstablishment: 'Présence déclarée',
  UpdateEstablishment: 'Présence modifiée',
  CloseEstablishment: 'Présence fermée',
  UpdateTenantProfile: 'Compte modifié',
};
const labelOf = (entry: HistoryEntry): string => LABELS[entry.label] ?? (entry.command_name !== undefined && entry.label === entry.command_name ? (LABELS[entry.command_name] ?? entry.label) : entry.label);

/**
 * Historique d'un objet sous son formulaire, dans le panneau de droite (maquette du 2026-10-15) : ses commandes
 * réussies, lues dans le journal d'audit par `GetObjectHistory`, de la plus récente à la plus ancienne.
 */
export function PanelHistory({ type, id, version }: { type: string; id: string; version: number }) {
  const services = useAppServices();
  const [loaded] = useLoad<HistoryEntry[]>(`panel-history:${type}/${id}/${version}`, async () => (await services.client.query<HistoryEntry[]>('GetObjectHistory', { object_type: type, id })).data);
  return (
    <section className="ay-tenant__panelhistory" aria-label="Historique">
      <h3 className="ay-tenant__panelhead">Historique</h3>
      {loaded.status === 'loading' && <Loading />}
      {loaded.status === 'error' && <p className="ay-text ay-text--muted">Historique indisponible.</p>}
      {loaded.status === 'ready' && loaded.value.length === 0 && <p className="ay-text ay-text--muted">Aucune modification enregistrée.</p>}
      {loaded.status === 'ready' && loaded.value.length > 0 && (
        <ol className="ay-history">
          {[...loaded.value].reverse().map((entry, index) => (
            <li key={`${entry.at}-${index}`} className="ay-history__entry">
              <span className="ay-history__dot" aria-hidden="true" />
              <span className="ay-history__body">
                <strong>{labelOf(entry)}</strong>
                <span className="ay-history__meta">
                  {new Date(entry.at).toLocaleString('fr-FR', { dateStyle: 'medium', timeStyle: 'short' })}
                  {entry.actor_name === null ? '' : ` · ${entry.actor_name}`}
                </span>
              </span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
